import React from 'react';
import logo from '@/assets/logo.png';

const SIZES = {
  sm: { height: 13, width: 118 },
  md: { height: 16, width: 145 },
  lg: { height: 22, width: 200 },
};

export const BrandLogo = ({ size = 'sm', className = '', ...rest }) => {
  const dims = SIZES[size] || SIZES.sm;
  return (
    <span
      role="img"
      aria-label="Bella Maison"
      data-testid="brand-logo"
      className={className}
      style={{
        display: 'inline-block',
        ...dims,
        backgroundColor: 'currentColor',
        WebkitMaskImage: `url(${logo})`,
        maskImage: `url(${logo})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'left center',
        maskPosition: 'left center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
      }}
      {...rest}
    />
  );
};
